module.exports = require("./pl-PL.js");